import { useEffect } from "react";
import { useHistory } from "react-router-dom";

const RedirectToIosFaq = () => {
  const history = useHistory();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const mobile = params.get("mobile");

    if (mobile === "true") {
      history.replace("/ios-faq/mobile");
    } else {
      history.replace("/ios-faq");
    }
  }, [history]);

  return null;
};

export default RedirectToIosFaq;
